import { db } from "../firebase/config";
import firebase from "firebase/app";
import getTime from "./getTime";

const addReply = (userID: string, message: string, commentID: string) => {
  db.collection("comments")
    .doc(commentID)
    .set(
      {
        replies: firebase.firestore.FieldValue.arrayUnion({
          user: db.collection("profiles").doc(userID),
          message,
          commentID,
          time: getTime(),
        }),
      },
      { merge: true }
    );
};

export default addReply;
